import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Get, Put, Post } from 'utils/axios-token'
import { requestSuccess, requestError } from 'utils/requestHandler'
import { convertSearchObjectToBase64 } from 'utils/objToBase64'

import Lang from 'Lang/General'

const HOC = ( WrappedComponent ) => {
  class WithHOC extends Component {
    state = {
      loading: false,
      selectedExpoMagazine: null
    }

    onChangeExpoMagazineHOC = ( key, value ) => this.setState({ [key]: value })

    load = val => this.setState({loading: val})

    getSelectedExpoMagazine = portalUserID => Get(
      `/api/v1/fex/magazines?query=${convertSearchObjectToBase64({"is_paginated":false,"filter":{"user_id":portalUserID}})}`,
      payload => this.setState({ selectedExpoMagazine: payload?.data?.[0]??null }),
      error => requestError(error),
      this.load
    )

    updateExpoMagazine = dataToSubmit => Put(
      `/api/v1/fex/magazines/${dataToSubmit.id}`,
      dataToSubmit,
      () => {
        this.props.onChangePortalUsersHOC('showUploadModal', false )
        this.getSelectedExpoMagazine(dataToSubmit.user_id)
        requestSuccess(Lang[ 'RECORD_UPDATED_SUCCESSFULLY' ][ this.props.data.languageReducer.userSettings.admin_panel_language ])
      },
      error => requestError(error),
      this.load
    )

    createExpoMagazine = dataToSubmit => Post(
      `/api/v1/fex/magazines`,
      dataToSubmit,
      () => {
        this.props.onChangePortalUsersHOC('showUploadModal', false )
        this.getSelectedExpoMagazine(dataToSubmit.user_id)
        requestSuccess(Lang[ 'RECORD_CREATE_SUCCESS' ][ this.props.data.languageReducer.userSettings.admin_panel_language ])
      },
      error => requestError(error),
      this.load
    )

    render = () => {
      return(
        <>
          <WrappedComponent
            { ...this.props }
            { ... this.state }
            onLoadExpoMagazine={this.state.loading}

            createExpoMagazine={this.createExpoMagazine}
            onChangeExpoMagazineHOC={ this.onChangeExpoMagazineHOC }
            getSelectedExpoMagazine={this.getSelectedExpoMagazine}
            updateExpoMagazine={this.updateExpoMagazine} 
            />
        </>
      )
    }

  }
  const mapStateToProps = state => ({ data: state })
  return connect( mapStateToProps)( WithHOC )
}

export default HOC
